import { FromLink } from "../../../../utils/useNavigateFrom";
import Field, { DataSource } from "./Field";

class QCStatusField extends Field {
    field_type = "layer_qc_status_field";

    backend_table = "layer_meta";

    layer_id?: string;

    // * set the value from one of the the objects
    set_value(datasource: DataSource): this {
        // always reset the value
        this.value = null;
        this.value = this.value_filter(datasource.layer[this.fieldname_getter], datasource);
        this.layer_id = datasource.layer?.id || undefined;
        return this;
    }

    // * render react component, can be overwritten by special fields
    display_component(): JSX.Element {

        // * Consultant should use LabelLinkField, this is a fallback for backwards compatibility (copied from LayerField)
        if (this.fieldname_getter === "label" && this.layer_id) {
            return <FromLink to={`/layer/${this.layer_id}`}>{this.value}</FromLink>;
        }

        if (this.fieldname_getter.startsWith("qc_status")) {
            // strip qc_status_ from the fieldname_getter
            const config_value = this.fieldname_getter.replace("qc_status_", "");
            return <FromLink to={`/layer/${this.layer_id}/report/${config_value}`}>{this.value}</FromLink>;
        }
        return <span className={this.get_classname()}>{this.formatted_value()}</span>;
    }


}

export default QCStatusField;
